import React from "react";
import { Check, Clock, Users, Zap, AlertCircle } from "lucide-react";

const PricingSection = () => {
  const plans = [
    {
      name: "Explorador",
      type: "hourly",
      price: "3,100 MXN",
      period: "mes",
      paymentLink:"https://mpago.la/1v6PfXY",
      description: "El camino ideal para comenzar su aventura. Ideal para probar las experiencia y descubrir el potencial tecnológico.",
      features: [
        "8 clases al mes · 2 por semana",
        "Horarios flexibles",
        "Contenido adaptado al nivel del alumno",
        "Retroalimentación al final del mes",
      ],
      popular: false,
      cta: "Empezar a explorar"
    },
    {
      name: "Lab Member",
      type: "monthly",
      price: "8,400 MXN",
      period: "24 clases",
      paymentLink:"https://mpago.la/2wxsBYi",
      description: "La experiencia completa del laboratorio. Ideal para avances visibles y consistentes",
      features: [
        "24 clases personalizadas",
        "Seguimiento quincenal de progreso",
        "Reportes de aprendizaje",
        "Prioridad para agendar horarios", 
      ],
      popular: true,
      cta: "Conviértete en Lab Member",
      badge: "El plan preferido por los papás porque combina avance real, estructura y acompañamiento."
    },
     {
      name: "Master Club",
      type: "hourly",
      price: "15,600 MXN",
      period: "48 clases",
      paymentLink:"https://mpago.la/2egPt8f",
      description: "El nivel más alto de acompañamiento y resultados.",
      features: [
        "48 clases totalmente personalizadas",
        "Seguimiento quincenal de progreso",
        "Reportes de aprendizaje",
        "Feedback para papás",
        "Cambios de horario sin costo",
        "Precio preferencial en clases extra",
        "Descuentos epeciales en talleres y cursos de temporada"
      ],
      popular: false,
      cta: "Entrar al Master Club "
    }

  ];

  return (
    <section className="pricing-section" id="pricing">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">
            Invierte en el 
            <span className="title-highlight"> futuro de tu hijo</span>
          </h2>
          <p className="section-subtitle">
            Planes flexibles diseñados para adaptarse a las necesidades de cada familia.
          </p>
        </div>

        <div className="urgency-banner">
          <AlertCircle className="urgency-icon" />
          <span className="urgency-text">
            <strong>Plazas limitadas:</strong> Solo quedan 12 cupos disponibles este mes
          </span>
        </div>
        
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && (
                <div className="popular-badge">
                  <Zap className="badge-icon" />
                  <span>Más Popular</span>
                </div>
              )}
              
              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price-currency">$</span>
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              
              <div className="plan-features">
                {plan.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="feature-item">
                    <Check className="feature-check" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
              
             <a
  href={plan.paymentLink}
  target="_blank"
  rel="noopener noreferrer"
  className={`plan-cta ${plan.popular ? 'primary' : 'secondary'}`}
  onClick={() => {
    window.fbq?.("track", "InitiateCheckout");
    console.log(`Checkout: ${plan.name}`);
  }}
>
  {plan.cta}
</a>


              {plan.badge && (
                <span className="plan-badge-text">
                ⭐ {plan.badge}
                 </span>
                )}
              
              <div className="plan-glow"></div>
            </div>
          ))}
        </div>

        <div className="pricing-info">
          <div className="info-grid">
            <div className="info-item">
              <Clock className="info-icon" />
              <div className="info-content">
                <h4>Horarios Flexibles</h4>
                <p>Clases de lunes a sábado de 2:00 PM a 8:00 PM</p>
              </div>
            </div>
            <div className="info-item">
              <Users className="info-icon" />
              <div className="info-content">
                <h4>Grupos Pequeños</h4>
                <p>Máximo 8 estudiantes por clase para atención personalizada</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;